import { get } from 'lodash'
import { SystemTheme } from 'hooks/useUiState/types'

type ColorObj = { default: string }

export const getThemePath = (colorSettings: Record<string, string>, name: string) =>
  get(colorSettings, name)

export const getThemeProp = <T = any>(sysTheme: SystemTheme, path: string) =>
  get(sysTheme, path) as T | undefined

export const getDefaultColor = (
  colorSettings: Record<string, string>,
  name: string,
  sysTheme: SystemTheme
) => {
  const path = getThemePath(colorSettings, name)
  const color = getThemeProp<ColorObj>(sysTheme, path)
  return color?.default
}
